export const selectThank = state => state.messages.thank;
export const selectWait = state => state.messages.wait;
export const isLoading = state => state.messages.loading;
export const selectResponse = state => state.messages.message;
